import { RemixiconComponentType } from '@remixicon/react';

export const IconChartLine: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M2 22V2h2v18h18v2H2ZM20.486 3.126a1 1 0 0 1 .388 1.36l-5.485 9.858a1 1 0 0 1-1.732.029l-2.577-4.296-3.186 6.37a1 1 0 1 1-1.788-.894l4-8a1 1 0 0 1 1.752-.067l2.624 4.374 4.644-8.346a1 1 0 0 1 1.36-.388Z" />
  </svg>
);
